import * as React from "react";

interface DialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: React.ReactNode;
}

export function Dialog({ open, onOpenChange, children }: DialogProps) {
  return open ? (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-lg relative">
        {children}
      </div>
    </div>
  ) : null;
}

interface DialogSectionProps {
  children: React.ReactNode;
  className?: string; // 🔹 Dodane, żeby można było przekazywać `className`
}

export function DialogContent({ children, className }: DialogSectionProps) {
  return <div className={className}>{children}</div>;
}

export function DialogHeader({ children, className }: DialogSectionProps) {
  return <div className={`border-b p-4 text-lg font-semibold ${className || ""}`}>{children}</div>;
}

export function DialogTitle({ children, className }: DialogSectionProps) {
  return <h2 className={`text-lg font-bold ${className || ""}`}>{children}</h2>;
}

export function DialogFooter({ children, className }: DialogSectionProps) {
  return <div className={`border-t p-4 flex justify-end ${className || ""}`}>{children}</div>;
}
